import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface ServiceDetailContentProps {
  data: {
    overview: string;
    benefits: Array<{
      icon: string;
      title: string;
      description: string;
    }>;
  };
}

const ServiceDetailContent = ({ data }: ServiceDetailContentProps) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="py-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-8">
        {/* Overview */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center mb-12"
        >
          <h2 className="font-poppins font-bold text-2xl lg:text-3xl text-gray-900 mb-4">
            Hizmet Detayları
          </h2>
          <p className="font-poppins text-base text-gray-600 leading-relaxed">
            {data.overview}
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-gradient-to-br from-[#007dff]/5 to-[#007dff]/10 rounded-xl p-5 hover:shadow-lg transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-2xl text-[#007dff]`}></i>
              </div>
              <h3 className="font-poppins font-semibold text-base text-gray-900 mb-2">
                {benefit.title}
              </h3>
              <p className="font-poppins text-[13px] text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailContent;
